module.exports = __webpack_public_path__ + "resources/img/vv.7561fbaa.png";